import React from 'react';
import { I } from '../../common/v5/config';

const V5Select = ({ 
  label, 
  value, 
  options = [], 
  onChange, 
  required = false, 
  placeholder = '', 
  disabled = false,
  name,
  id
}) => {


  const handleChange = (e) => {
    const selectedValue = e.target.value;
    
    if (onChange) {
      onChange(selectedValue, name);
    }
  };

  return (
    <div className="v5-form-group">
      {label && (
        <label className="v5-form-label">
          {I(label)}
          {required && <span className="required-asterisk">*</span>}
        </label>
      )}
      <select
        id={id}
        name={name}
        value={value || ''}
        onChange={handleChange}
        disabled={disabled}
        className="v5-form-select"
      >
        {placeholder && (
          <option value="" disabled>
            {I(placeholder)}
          </option>
        )}
        {options && options.length > 0 ? (
          options.map((option) => (
          <option key={option.id || option.value} value={option.id || option.value}>
              {I(option.name || option.label || option.text)}
            </option>
          ))
        ) : (
          <option value="" disabled>
            {console.log('=== V5Select: No options available ===') || I('No options available')}
          </option>
        )}
      </select>
    </div>
  );
};

export default V5Select; 